import { getUserBrowser, getUserOs } from '../utils'

export const getSystemEventParameters = (
  systemEventsNames: string[] | undefined = [],
  name: string,
  userAgent: string | undefined,
) => {
  const userOs = getUserOs(userAgent)
  const userBrowser = getUserBrowser(userAgent)

  if (systemEventsNames.includes(name)) {
    return {
      os_name: userOs?.name,
      os_version: userOs?.version,
      user_agent_name: userBrowser?.name,
      user_agent_version: userBrowser?.version,
    }
  }

  return {}
}
